<div class="flex flex-wrap gap-y-4 p-4">
  <div *ngFor="let data of filteredDataList()" [ngClass]="data.subItems.length > 0 ? 'w-full' : 'w-1/4' " class="break-words">
    <div class="mb-4">
      <div *ngIf="data.name" class="text-lg font-semibold mb-1 pr-2">{{ data.name }}</div>
      @if(data.value === "True" || data.value === "False") {
      <i [ngClass]="data.value === 'True' ? 'pi pi-check' : 'pi pi-times'"></i>
      }
      @else {
      <div class="text-base text-gray-600 pr-2">{{ !data.value ? '--' : data.value }}</div>
      @if(data.subItems.length > 0) {
        <app-view [dataList]="data.subItems"></app-view>
      }
      }
    </div>
  </div>
</div>
